import { supabase } from './supabase'
import type { SerialCodeValidation } from '@/types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rpc = supabase.rpc.bind(supabase) as (fn: string, args?: Record<string, unknown>) => any

export async function validateSerialCode(code: string): Promise<SerialCodeValidation> {
  const { data, error } = await rpc('validate_serial_code', {
    p_code: code.trim().toUpperCase(),
  })

  if (error) {
    return { valid: false, error: 'Failed to validate serial code' }
  }

  return data as SerialCodeValidation
}

export async function redeemSerialCode(serialCodeId: string, clientId: string): Promise<void> {
  const { error } = await rpc('redeem_serial_code', {
    p_serial_code_id: serialCodeId,
    p_client_id: clientId,
  })

  if (error) {
    throw new Error('Failed to redeem serial code')
  }
}
